import { analytics, trackEvent } from "../analytics/analyticsClient";
const readTrafficValue = (key: string) => {
	try {
		return sessionStorage.getItem(`qt.traffic.${key}`) || undefined;
	} catch {
		return undefined;
	}
};
const source = readTrafficValue("utm_source");
const medium = readTrafficValue("utm_medium");
const campaign = readTrafficValue("utm_campaign");
if (source || medium || campaign) {
	trackEvent("traffic_source_captured", {
		...source && { source },
		...medium && { medium },
		...campaign && { campaign }
	});
}
const capturePageview = () => analytics.pageview({
	url: window.location.href,
	pathname: window.location.pathname
});
if ("requestIdleCallback" in window) {
	requestIdleCallback(capturePageview, { timeout: 3e3 });
} else {
	setTimeout(capturePageview, 2e3);
}